import React, { useState } from 'react';
import styled from 'styled-components';
import { TokenList, TokenSearchBar } from '../../components/explore/TokenList';

const PageContainer = styled.div`
  width: 100%;
  min-height: calc(100vh - 80px);
  padding: 16px 0 100px 0;
  box-sizing: border-box;
  
  @media (max-width: 480px) {
    padding: 12px 0 100px 0;
  }
`;

const SearchContainer = styled.div`
  margin-bottom: 20px;
  padding: 0 16px;
  
  @media (max-width: 480px) {
    padding: 0 12px;
  }
`;

const ExplorePWA: React.FC = () => {
  const [searchQuery, setSearchQuery] = useState('');

  return (
    <PageContainer>
      <SearchContainer>
        <TokenSearchBar searchQuery={searchQuery} setSearchQuery={setSearchQuery} />
      </SearchContainer>
      <TokenList searchQuery={searchQuery} />
    </PageContainer>
  );
};

export default ExplorePWA;

